import React, { useState, useEffect, useRef } from "react";
import leaf from "../../Assets/Images/leaf.png";
import plus from "../../Assets/Images/FaqsImages/plus.webp";
import cross from "../../Assets/Images/FaqsImages/cross.webp";
import AOS from "aos";
import { Sparkles } from "lucide-react";
const faqsLeft = [
  {
    id: "01",
    q: "How early should I book for bridal services?",
    a: "We recommend booking bridal services at least 3–6 months in advance to ensure availability and proper planning.",
  },
  {
    id: "02",
    q: "Are your beauty professionals trained and certified?",
    a: "Yes, all our professionals are fully trained, certified, and experienced in their respective services.",
  },
  {
    id: "03",
    q: "What is your cancellation or rescheduling policy?",
    a: "Cancellations or rescheduling can be done up to 24 hours prior to the appointment without any charge.",
  },
];

const faqsRight = [
  {
    id: "04",
    q: "Do you follow hygiene and safety standards?",
    a: "Yes, we strictly follow hygiene and sanitation protocols. All tools are cleaned and sanitized before and after every service.",
  },
  {
    id: "05",
    q: "What are the terms and conditions for the cancellation policy?",
    a: "Late cancellations may incur a minimal fee. Please review our detailed terms during booking.",
  },
];

const FAQCard = ({ item, active, aos, delay, onClick }) => {
  const contentRef = useRef(null);
  const [maxHeight, setMaxHeight] = useState("0px");

  useEffect(() => {
    if (active && contentRef.current) {
      setMaxHeight(`${contentRef.current.scrollHeight}px`);
    } else {
      setMaxHeight("0px");
    }
  }, [active, item.a]);

  return (
    <div
      data-aos={aos}
      data-aos-delay={delay}
      data-aos-once="true"
      onClick={onClick}
      className={`rounded-2xl border p-2 md:p-6 cursor-pointer transition-all duration-300 ${
        active ? "bg-[#FFF1E8]" : "bg-white"
      }`}
    >
      <div className="flex justify-between items-start gap-4">
        <div className="flex gap-4">
          <div className="flex-shrink-0 w-10 h-10 md:w-14 md:h-14 xl:w-12 xl:h-12 rounded-full bg-gray-100 text-[#842800] flex items-center justify-center text-sm md:text-lg font-semibold">
            {item.id}
          </div>

          <div className="w-full">
            <h4 className="font-medium  font-robotoflex text-sm md:text-xl md:mt-3 max-w-md">
              {item.q}
            </h4>

            {/* Animated container */}
            <div
              className="overflow-hidden transition-all duration-500 ease-in-out"
              style={{
                maxHeight,
                opacity: active ? 1 : 0,
              }}
            >
              <p
                ref={contentRef}
                className="text-sm text-[#353535] mt-3 leading-relaxed pb-2" // pb-2 for breathing room
              >
                {item.a}
              </p>
            </div>
          </div>
        </div>

        <img
          src={active ? cross : plus}
          className="w-3 h-3 md:w-5 md:h-5 mt-1 md:mt-3 transition-transform duration-300"
          style={{ transform: active ? "rotate(180deg)" : "rotate(0deg)" }}
          alt="toggle"
        />
      </div>
    </div>
  );
};

const FAQs = () => {
  const [activeId, setActiveId] = useState("");

  const toggleFAQ = (id) => {
    setActiveId((prev) => (prev === id ? null : id));
    setTimeout(() => AOS.refresh(), 100);
  };

  return (
    <section className="bg-[#FFFAF9] px-4 md:px-8 lg:px-12 py-8 md:py-12 lg:py-16">
      <div className=" mx-auto">
        <div className="grid lg:grid-cols-2 gap-6 mb-6 md:mb-10 ">
          <div className="space-y-4">
            <div className="relative w-fit">
              <div className="absolute -inset-1 bg-gradient-to-r from-[#ab310c] to-[#EDB5A4] rounded-full blur opacity-20 group-hover:opacity-30 transition duration-1000 group-hover:duration-200 animate-pulse" />
              <div className="relative uppercase font-robotoflex flex items-center gap-2 sm:gap-3 border-2 border-white/30 bg-white/90 backdrop-blur-sm rounded-full text-[#ab310c] px-4 sm:px-6 py-1.5 text-sm sm:text-base tracking-wide font-semibold shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 group">
                <img
                  src={leaf}
                  alt="leaf"
                  className="w-5 h-5 sm:w-6 sm:h-6 transition-transform group-hover:rotate-12 duration-300"
                />
                <span className="bg-gradient-to-r from-[#ab310c] to-[#8a290a] bg-clip-text text-transparent">
                  FAQ's
                </span>
                <Sparkles className="w-4 h-4 sm:w-5 sm:h-5 text-amber-500 ml-1" />
              </div>
            </div>

            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-philosopher font-bold text-gray-900 leading-tight tracking-tight">
              <span className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 bg-clip-text text-transparent">
                You Need to &nbsp;
              </span>
              {/* <br /> */}
              <span className="relative">
                <span className="bg-gradient-to-r from-[#ab310c] via-[#d44a20] to-[#EDB5A4] bg-clip-text text-transparent">
                  Know
                </span>
                <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-32 h-1 bg-gradient-to-r from-[#ab310c] to-[#EDB5A4] rounded-full" />
              </span>
            </h1>
          </div>

          <div data-aos="fade-left" data-aos-delay={200}>
            <p className="text-sm md:text-base text-[#707070] lg:text-[#1E1E1E] max-w-2xl text-left lg:text-right leading-relaxed translate-y-0 lg:translate-y-14  ">
              Stay connected with the world of beauty and self-care! Subscribe
              to our newsletter and be the first to discover our latest
              services, exclusive offers, seasonal beauty tips, and expert
              recommendations from our stylists.
            </p>
          </div>
        </div>

        {/* FAQ Grid */}
        <div className="grid lg:grid-cols-2 gap-3 md:gap-10">
          <div className="space-y-2 md:space-y-6">
            {faqsLeft.map((item, index) => (
              <FAQCard
                key={item.id}
                item={item}
                aos="fade-up"
                delay={index * 100}
                active={activeId === item.id}
                onClick={() => toggleFAQ(item.id)}
              />
            ))}
          </div>

          <div className="space-y-2 md:space-y-6">
            {faqsRight.map((item, index) => (
              <FAQCard
                key={item.id}
                item={item}
                aos="fade-up"
                delay={index * 100 + 200}
                active={activeId === item.id}
                onClick={() => toggleFAQ(item.id)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQs;
